import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

const SidebarContext = createContext<
  | {
      sidebarCollapsed: boolean;
      setSidebarCollapsed: Dispatch<SetStateAction<boolean>>;
    }
  | undefined
>(undefined);

const SidebarProvider = (props: React.PropsWithChildren<{}>) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(true);

  return (
    <SidebarContext.Provider
      value={{
        sidebarCollapsed,
        setSidebarCollapsed,
      }}
      {...props}
    />
  );
};

const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};

export { SidebarProvider, useSidebar };
